export const sharedPaths = {
  root: '/',
  publicLanding: '/',
  cashbackCalculator: '/cashback-calculator',
  legacyLogin: '/login',
  legacySignIn: '/signin',
  legacySignInPhone: '/signin/phone',
  legacySignInOtp: '/signin/otp',
  legacyLanding: '/landing',
  legacyFtue: '/ftue',
  legacyTerms: '/terms',
  legacyLinkExpired: '/link-expired',
  legacyEndUser: '/end-user',
  legacyConfirmCashback: '/confirm-cashback',
  legacyCashOut: '/cash-out',
  legacyHsaPaydays: '/hsa-paydays',
  legacyExpenses: '/expenses',
  legacyNoExpensesRemaining: '/no-expenses-remaining',
  legacyNoExpenseFound: '/no-expense-found',
  legacyFinchConnection: '/finch-connection',
  legacyPiiVerification: '/pii-verification',
  legacyOnboarding: '/onboarding',
  legacyOnboardingEmailVerification: '/onboarding/email-verification',
  legacyOnboardingPhoneVerification: '/onboarding/phone-verification',
  legacyOnboardingOtpVerification: '/onboarding/otp-verification',
  legacyOnboardingCompleteProfile: '/onboarding/complete-profile',
  legacyOnboardingPersonalDetails: '/onboarding/personal-details',
  legacyOnboardingFindExpenses: '/onboarding/find-expenses',
  legacyOnboardingFindExpensesSuccess: '/onboarding/find-expenses/success',
  legacyOnboardingFindExpensesProviders: '/onboarding/find-expenses/providers',
  legacyOrganization: '/organization',
  legacyOrganizationUnit: '/organization/unit',
} as const;
